import { toast } from "react-toastify";
import {
    fetchCreateCategoryRequest,
    fetchCreateCategorySuccess,
    fetchCreateCategoryFailure,
} from "./reducer";
import { CREATE_CATEGORY } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createCategory = (jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchCreateCategoryRequest());
    setLoading(true);

    try {
        const response = await determineBaseUrlAndPerformApiCall(
            CREATE_CATEGORY,
            "POST",
            jsonObj
        );

        if (response?.error) {
            dispatch(fetchCreateCategoryFailure(response.error.message));
            toast.error(response.error.message);
        } else {
            dispatch(fetchCreateCategorySuccess(response));
            dispatch(setSuccessMessage(true));
            onSuccess && onSuccess();   
        }
    } catch (error) {
        dispatch(fetchCreateCategoryFailure("Something went wrong"));
        toast.error("Something went wrong");
    } finally {
        setLoading(false);
    }
};